<template>
  <div class='FrenteLoja'
    :style="{ backgroundColor: Prefes.frentelojaCorFundo.corBackground }"
  >
    <enb-slide/>
    <enb-slogan/>
    <enb-category/>
    <enb-news/>
    <enb-destaques/>
    <story-access/>
    <whats-btn/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EnbSlide from '@/components/FrenteLoja/EnbSlide'
import EnbSlogan from '@/components/FrenteLoja/EnbSlogan'
import EnbCategory from '@/components/FrenteLoja/EnbCategory'
import EnbNews from '@/components/FrenteLoja/EnbNews'
import StoryAccess from '@/components/FrenteLoja/StoryAccess'
import WhatsBtn from '@/components/FrenteLoja/WhatsBtn'
import EnbDestaques from '@/components/FrenteLoja/EnbDestaques'
export default {
  name: 'FrenteLoja',
  components: { EnbSlide, EnbSlogan, EnbCategory, EnbNews, StoryAccess, WhatsBtn, EnbDestaques },
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.FrenteLoja {
  width: 100%;
  height: 100%;
  background-color: #EEEEEE;
  overflow: auto;
}
</style>
